import BaseRootOption from "%/dynamic-components/render-engine/classes/base-root-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class LoginState extends BaseRootOption {
  static label = "Login State";
  static descriptionMessage = "This will simulate the way this component will look when the user is logged in or out";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Logged In",
          value: "Logged In",
        },
        {
          label: "Logged Out",
          value: "Logged Out",
        },
      ],
    },
  };

  static defaultValue = "Logged In";
}
